import { render, staticRenderFns } from "./classes.vue?vue&type=template&id=a4bced40&scoped=true"
import script from "./classes.vue?vue&type=script&lang=js"
export * from "./classes.vue?vue&type=script&lang=js"
import style0 from "./classes.vue?vue&type=style&index=0&id=a4bced40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bced40",
  null
  
)

export default component.exports